var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 27,
    viewBox: "0 0 55 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.48217V21.1698C1 23.6452 3.00674 25.652 5.48217 25.652H49.5178C51.9933 25.652 54 23.6452 54 21.1698V13.326V5.48217C54 3.00674 51.9933 1 49.5178 1H5.48218C3.00674 1 1 3.00674 1 5.48217Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.46118L8.83727 10.0426C9.54517 10.6519 10.562 10.6911 11.3118 10.1379L12.3115 9.40029C13.0614 8.84707 14.0782 8.88621 14.7861 9.49553L15.5323 10.1378C16.1872 10.7016 17.1138 10.7815 17.8501 10.3378L21.2569 8.28515C22.0955 7.7799 23.1632 7.96007 23.8024 8.71471L25.0095 10.1396C25.7074 10.9634 26.902 11.0925 27.7498 10.4357L29.2337 9.28617C29.8802 8.78539 30.7529 8.72927 31.4545 9.14337L32.5006 9.76081C33.2938 10.229 34.2923 10.0909 34.9384 9.42361L35.7087 8.62794C36.3916 7.92259 37.4615 7.81316 38.2651 8.36648L41.5791 10.6485C42.3826 11.2018 43.4526 11.0924 44.1355 10.387L46 8.46118M7 15.8755L8.83727 17.1989C9.54517 17.7087 10.562 17.7415 11.3118 17.2786L12.3115 16.6614C13.0614 16.1985 14.0782 16.2312 14.7861 16.7411L15.5323 17.2786C16.1872 17.7503 17.1138 17.8172 17.8501 17.4459L21.2569 15.7282C22.0955 15.3055 23.1632 15.4562 23.8024 16.0877L25.0095 17.2801C25.7074 17.9694 26.902 18.0774 27.7498 17.5278L30.2987 15.8755M36.8831 15L41.5791 17.7059C42.3826 18.1689 43.4526 18.0773 44.1355 17.4871L46 15.8755",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringIcon);
export default __webpack_public_path__ + "static/media/stringIcon.d37b5fdbb4469e6fc43279a9df6a6aa0.svg";
export { ForwardRef as ReactComponent };